import * as React  from "react";
import {cs}        from "@Common/react/chain-services";

export const generic_bus_card_logo = ({session, specificationFields, specFieldOnChange, next}) => cs(
    ["specFieldDuplicates", ({}, next) => next([])],
    ["ordinalPosition", ({}, next) => next(2)],
    ["fieldMappings", ({session}, next) => next({
        "field_66": "agentDisplay1",
        "field_67": "agentDisplay2",
        "field_68": "agentDisplay3",
        "field_69": "agentDisplay4",
        "field_70": "agentDisplay5",
        "field_71": "agentDisplay6",
        "field_72": "agentDisplay7",
        "field_73": "",
        "field_74": "",
        "field_75": "",
        "field_76": "agentDisplay8",
        "field_77": "",
        "field_78": ""
    })],

    (({specFieldDuplicates, ordinalPosition, fieldMappings}, next) => next(
        
        specificationFields.map( field => {
            if (!field.data) {
                if( Object.keys(fieldMappings).includes(field.fieldKey) ) {
                    field.data = session.data.agent?.[fieldMappings[field.fieldKey]];
                }
            }
            // update field with new ordinal position
            field.ordinal = ordinalPosition;
            specFieldDuplicates.push(field);
            ordinalPosition++;
        }
    ))),
    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),
    ({specFieldDuplicates}) => next(specFieldDuplicates)
);